import {Controller} from "@hotwired/stimulus"
import Croppie from "croppie" // Alternative https://sharp.pixelplumbing.com/api-resize/ or https://fengyuanchen.github.io/cropperjs/ or https://lemonadejs.com/docs/plugins/image-cropper
import {DirectUpload} from "@rails/activestorage"
export default class extends Controller {
  static targets = ["form", "preview", "container", "fileInput", "imagesData", "overlay", "closePreview", "submitButton"]

  settings = {
    messagesFileTooLarge: "File is too large (max is 2 MB)",
    messagesInvalidFileType: "Invalid file type",
    messagesNoFileDropped: "No file dropped",
    allowedTypes: ["image/jpeg", "image/png"],
    maxSize: 2 * 1024 * 1024, // 2MB
  }

  connect() {
    this.addListeners()
    this.fileInputTarget.addEventListener("change", this.handleFileInputChange.bind(this))
    const {maxSize, messagesFileTooLarge, messagesInvalidFileType, messagesNoFileDropped, allowedTypes} = this.element.dataset
    this.settings = {
      ...this.settings,
      messagesFileTooLarge: messagesFileTooLarge || this.settings.messagesFileTooLarge,
      messagesInvalidFileType: messagesInvalidFileType || this.settings.messagesInvalidFileType,
      messagesNoFileDropped: messagesNoFileDropped || this.settings.messagesNoFileDropped,
      allowedTypes: allowedTypes ? allowedTypes.split(",") : this.settings.allowedTypes,
      maxSize: maxSize ? parseInt(maxSize) * 1024 * 1024 : this.settings.maxSize,
    }
  }

  disconnect() {
    this.removeListeners()
  }

  async onSubmit(event) {
    event.preventDefault()
    if (this.croppieInstance) {
      const blob = await this.croppieInstance.result({type: "blob", format: "png", circle: false})
      const file = new File([blob], "avatar.png", {type: "image/png"})

      const upload = new DirectUpload(file, "/rails/active_storage/direct_uploads")
      upload.create((error, blob) => {
        if (error) {
          alert("Upload failed: " + error)
        } else {
          const hiddenField = document.createElement("input")
          hiddenField.setAttribute("type", "hidden")
          hiddenField.setAttribute("name", "profile[avatar]")
          hiddenField.setAttribute("value", blob.signed_id)
          this.formTarget.appendChild(hiddenField)
          this.formTarget.submit()
        }
      })
      // Directly upload file.
      // const dataTransfer = new DataTransfer()
      // dataTransfer.items.add(file)
      // this.fileInputTarget.files = dataTransfer.files
      // this.formTarget.submit()
    }
  }

  onUpload(event) {
    event.preventDefault()
    this.fileInputTarget.click()
  }

  onClosePreview(event) {
    event.preventDefault()
    this.closePreviewTarget.classList.add("hidden")
    this.containerTarget.classList.remove("hidden")
    if (this.croppieInstance) {
      this.croppieInstance.destroy()
      this.croppieInstance = null
    }
  }

  showOverlay = () => {
    this.overlayTarget.classList.remove("opacity-0", "pointer-events-none")
    this.overlayTarget.classList.add("opacity-50")
  }

  hideOverlay = () => {
    this.overlayTarget.classList.add("opacity-0", "pointer-events-none")
    this.overlayTarget.classList.remove("opacity-50")
  }

  addListeners() {
    this.containerTarget.addEventListener("dragover", this.handleDragOver.bind(this))
    this.containerTarget.addEventListener("dragleave", this.handleDragLeave.bind(this))
    this.containerTarget.addEventListener("drop", this.handleDrop.bind(this))
    this.containerTarget.addEventListener("mouseenter", this.handleMouseEnter.bind(this))
    this.containerTarget.addEventListener("mouseleave", this.handleMouseLeave.bind(this))
  }

  removeListeners() {
    this.containerTarget.removeEventListener("dragover", this.handleDragOver.bind(this))
    this.containerTarget.removeEventListener("dragleave", this.handleDragLeave.bind(this))
    this.containerTarget.removeEventListener("drop", this.handleDrop.bind(this))
    this.containerTarget.removeEventListener("mouseenter", this.handleMouseEnter.bind(this))
    this.containerTarget.removeEventListener("mouseleave", this.handleMouseLeave.bind(this))
  }

  handleDragOver(event) {
    event.preventDefault()
    this.showOverlay()
  }

  handleDragLeave(event) {
    event.preventDefault()
    // this.hideOverlay()
  }

  handleMouseEnter(event) {
    event.preventDefault()
    this.showOverlay()
  }
  handleMouseLeave(event) {
    event.preventDefault()
    this.hideOverlay()
  }

  handleDrop(event) {
    event.preventDefault()
    let file = event.dataTransfer.files[0]
    this.processFile(file)
  }

  handleFileInputChange(event) {
    const file = event.target.files[0]
    if (file) {
      this.processFile(file)
    }
  }

  processFile(file) {
    if (!file) {
      window.dispatchEvent(new CustomEvent("toast", {detail: {type: "error", message: this.settings.messagesNoFileDropped}}))
      this.hideOverlay()
      return
    }

    if (!this.settings.allowedTypes.includes(file.type)) {
      window.dispatchEvent(new CustomEvent("toast", {detail: {type: "error", message: this.settings.messagesInvalidFileType}}))
      this.hideOverlay()
      return
    }

    if (file.size > this.settings.maxSize) {
      window.dispatchEvent(new CustomEvent("toast", {detail: {type: "error", message: this.settings.messagesFileTooLarge}}))
      this.hideOverlay()
      return
    }

    this.showCroppiePreview(file)
    this.hideOverlay()
  }

  showCroppiePreview(file) {
    this.closePreviewTarget.classList.remove("hidden")
    this.containerTarget.classList.add("hidden")

    if (this.croppieInstance) {
      this.croppieInstance.destroy()
      this.croppieInstance = null
    }

    this.containerTarget.classList.add("hidden")
    const reader = new FileReader()
    reader.onload = (e) => {
      this.croppieInstance = new Croppie(this.previewTarget, {
        circle: true,
        viewport: {width: 200, height: 200, type: "circle"},
        boundary: {width: 300, height: 300},
        enableOrientation: true,
        enableExif: true,
      })
      this.croppieInstance.bind({url: e.target.result})
    }
    reader.readAsDataURL(file)
    this.reader = reader
  }
}
